module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_04_770_280_zh-hant-857b1147f14e818bfcbb78f7b10797a9.jpg";